import { defineComponent as _defineComponent } from 'vue'
import { defaultThumbnailOnError } from '~/utils/image';
interface Props {
  publisher: {
    name: string;
    slug: string;
    logo_square: string;
  };
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PublisherLink',
  props: {
    publisher: null
  },
  setup(__props: any) {



return { __sfc: true,defaultThumbnailOnError }
}

})